export const RESULT_FILE_CONFIG = [
  {
    fileType: 0,
    name: 'wire_list.csv',
  },
  {
    fileType: 1,
    name: 'connector_list.csv',
  },
  {
    fileType: 2,
    name: 'harness.csv',
  },
]
